import { CanAccessGuard } from '@shared/guards/can-access.guard';

export const sharedGuards: any[] = [
  CanAccessGuard,
];

export * from '@shared/guards/can-access.guard';
